var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main",class:{'is-overflow-hidden' : _vm.isOverflowHidden},attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }